import { getGridPos, BLOCK_SIZE } from './utils'

class Tile {
  constructor(gridSpot) {
    const pos = getGridPos(gridSpot)
    this.gridSpot = gridSpot
    this.x = pos.x
    this.y = pos.y
    this.type = 'DEFAULT'

    this.reset()
  }

  reset(){
    this.neighbors = null
  }

  addNeighbors(neighborTop, neighborRight, neighborBottom, neighborLeft) {
    this.neighbors = {
      top: neighborTop,
      right: neighborRight,
      bottom: neighborBottom,
      left: neighborLeft,
    }
  }

  addDiagonalNeighbors(tl, tr, br, bl) {
    this.diagonalNeighbors = {
      tl: tl,
      right: tr,
      bottom: br,
      left: bl,
    }
  }

  draw(c) {
    c.beginPath()
    c.strokeStyle = '#cdcdcd'
    c.rect(this.x, this.y, BLOCK_SIZE, BLOCK_SIZE)
    c.fillStyle = '#ff0000'
    c.fill()
    c.stroke()
    c.closePath()
  }

  update(c) {
    this.draw(c)
  }
}

export default Tile
